module.exports = __webpack_public_path__ + "f1fa0de34bbebf15676836c8e37b017b.svg";